import React from "react";
import FieldString from "../../../fields3/generic/string/string";
import FieldConfig from "../../proto/field-config";
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups";
import FieldPassword_FormElement from "./render/form-element";

export default class FieldPassword extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Password";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Password input field"
        this.icon               = 'i5-email';


        this.renderComponents.formElement   = FieldPassword_FormElement


    }
}